import Vue from 'vue'
import Router from 'vue-router'

//Main Pages

import Map from '@/pages/Map'
import Tree from '@/pages/Tree'
import Profile from '@/pages/Profile'
import About from '@/pages/About'
import About_us from '@/pages/About_us'
import About_de from '@/pages/About_de'

//Admin Pages

import CountriesAdmin from '@/pages/admin/Countries'
import SpeciesAdmin from '@/pages/admin/Species'
import SerialesAdmin from '@/pages/admin/Seriales'
import EcosystemsAdmin from '@/pages/admin/Ecosystems'
import ReservesAdmin from '@/pages/admin/Reserves'
import ReserveAdminDetails from '@/pages/admin/ReserveDetails'
import TransactionsAdmin from '@/pages/admin/Transactions'
import TransactionAdminDetails from '@/pages/admin/TransactionDetails'
import AssignSeedsAdmin from '@/pages/admin/AssignSeeds'

//Other Pages

import Terms from '@/pages/Terms'
import Langs from '@/pages/Langs'

import store from '../store'

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/',
      name: 'Root',
      redirect: '/map'
    },
    {
      path: '/map/',
      name: 'map',
      component: Map
    },
    {
      path: '/map/:reserveId',
      name: 'ReserveMap',
      component: Map
    },
    {
      path: '/map/:reserveId/:userId',
      name: 'ReserveUserMap',
      component: Map
    },
    {
      path: '/tree/:reserveId/:treeId',
      name: 'Tree',
      component: Tree
    },
    {
      path: '/me',
      name: 'Profile',
      component: Profile,
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: '/profile/:id',
      name: 'UserProfile',
      component: Profile
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/about_us',
      name: 'About_us',
      component: About_us
    },
    {
      path: '/about_de',
      name: 'About_de',
      component: About_de
    },
    {
      path: '/admin/countries',
      name: 'CountriesAdmin',
      component: CountriesAdmin,
      meta: {
        requiresAuth: true,
        is_admin : true
      }
    },
    {
      path: '/admin/species',
      name: 'SpeciesAdmin',
      component: SpeciesAdmin,
      meta: {
        requiresAuth: true,
        is_admin : true
      }
    },
    {
      path: '/admin/seriales',
      name: 'SerialesAdmin',
      component: SerialesAdmin,
      meta: {
        requiresAuth: true,
        is_admin : true
      }
    },
    {
      path: '/admin/ecosystems',
      name: 'EcosystemsAdmin',
      component: EcosystemsAdmin,
      meta: {
        requiresAuth: true,
        is_admin : true
      }
    },
    {
      path: '/admin/reserves',
      name: 'ReservesAdmin',
      component: ReservesAdmin,
      meta: {
        requiresAuth: true,
        is_admin : true
      }
    },
    {
      path: '/admin/reserves/:id',
      name: 'ReserveAdminDetails',
      component: ReserveAdminDetails,
      meta: {
        requiresAuth: true,
        is_admin : true
      }
    },
    {
      path: '/admin/transactions',
      name: 'TransactionsAdmin',
      component: TransactionsAdmin,
      meta: {
        requiresAuth: true,
        is_admin : true
      }
    },
    {
      path: '/admin/transactionDetail/:id',
      name: 'TransactionAdminDetails',
      component: TransactionAdminDetails,
      meta: {
        requiresAuth: true,
        is_admin : true
      }
    },
    {
      path: '/admin/assignseeds',
      name: 'AssignSeedsAdmin',
      component: AssignSeedsAdmin,
      meta: {
        requiresAuth: true,
        is_admin : true
      }
    },
    {
      path: '/langs',
      name: 'Langs',
      component: Langs
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  await waitReady()
  const isLoggedIn = store.state.auth.user != null && store.state.auth.user != undefined
  const isAdmin = store.state.auth.isAdmin
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (!isLoggedIn) {
      next({path: '/'})
    } else {
      if(to.matched.some(record => record.meta.is_admin)) {
        if(isAdmin){
          next()
        } else {
          alert('¡Tines que ser administrador para ver esta sección!')
          next({path: '/'})
        }
      } else {
        next()
      }
    }
  } else {
    next() 
  }
})

const waitReady = () => new Promise((resolve) => {
  const checkReady = () => {
    if (store.state.auth.ready) {
      resolve()
    } else {
      setTimeout(checkReady, 100)
    }
  }
  checkReady()
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js